// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".listingFooter_DFVmL{background:var(--cp-gray-9)}.description_1fV-l,.listingFooter_DFVmL,.listingFooterItem_tkBMe{display:grid;grid-template-columns:1fr;max-width:100%;min-width:0;width:100%}.listingFooterItem_tkBMe{gap:36px;justify-items:center;padding:6rem 0 8rem}.content_Fx6jH{margin:auto;overflow:hidden;padding:0 1rem;position:relative}@media only screen and (min-width:1264px){.content_Fx6jH{padding:0 4.8rem}}.content_Fx6jH.description_1fV-l{gap:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listingFooter": "listingFooter_DFVmL",
	"description": "description_1fV-l",
	"listingFooterItem": "listingFooterItem_tkBMe",
	"content": "content_Fx6jH"
};
module.exports = ___CSS_LOADER_EXPORT___;
